import React, { Component } from "react";
import "./CertificationCard.css";
import { Fade } from "react-reveal";
import { withTranslation } from "react-i18next";

class CertificationCard extends Component {
  getCertificationKey(index) {
    const certKeys = [
      "awsCloudPractitioner",
      "scrumDeveloper",
      "reactCoursera",
      "oracleJavaProfessional",
      "oracleJavaAssociate",
      "agileFoundation",
      "androidUdacity",
      "gameDesign",
      "ibmSecurity",
      "acmEcpc",
    ];
    return certKeys[index] || `cert${index}`;
  }

  render() {
    const certificate = this.props.certificate;
    const certIndex = this.props.certIndex;
    const theme = this.props.theme;
    const { t } = this.props;
    const certKey = this.getCertificationKey(certIndex);

    return (
      <Fade bottom duration={2000} distance="20px">
        <div className="cert-card">
          <div className="content">
            <a
              href={certificate.certificate_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="content-overlay"></div>
              <div
                className="cert-header"
                style={{ backgroundColor: certificate.color_code }}
              >
                <img
                  className="logo_img"
                  src={require(`../../assets/images/${certificate.logo_path}`)}
                  alt={t(`portfolio.certifications.${certKey}.altName`)}
                />
              </div>
              <div className="content-details fadeIn-top">
                <h3 className="content-title" style={{ color: theme.body }}>
                  {t("certifications.certificateLabel")}
                </h3>
              </div>
            </a>
          </div>
          <div className="cert-body">
            <h2 className="cert-body-title" style={{ color: theme.text }}>
              {t(`portfolio.certifications.${certKey}.title`)}
            </h2>
            <h3
              className="cert-body-subtitle"
              style={{ color: theme.secondaryText }}
            >
              {t(`portfolio.certifications.${certKey}.subtitle`)}
            </h3>
          </div>
        </div>
      </Fade>
    );
  }
}

export default withTranslation()(CertificationCard);
